import React from "react";
import outline from "../../assets/icons/about_img.svg";
import { ArrowRight, ChevronRight } from "lucide-react";

const AboutExp = () => {
  return (
    <div
      className=" xl:py-28 lg:py-20 relative md:py-14 py-10  bg-almond "
      style={{
        backgroundImage: `url(${outline})`,
        backgroundSize: "auto",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <div data-aos="fade-up" className="xl:w-[1200px] relative  w-11/12 mx-auto  flex-col z-10">
        <div className=" w-full flex  flex-col lg:flex-row justify-between gap-10">
          <div className="w-full  xl:w-[55%] space-y-3">
            <div>
              <h2 className="lg:text-4xl md:text-3xl text-xl font-bold mt-2 text-matcha leading-tight">
                Clinical Expertise
              </h2>
              <p className="text-base text-matcha font-normal py-2.5">
                With over a decade of experience in Surgical Oncology, Dr.
                Hemanth Makineni has successfully performed more than{" "}
                <span className="font-semibold">
                  5,000 complex and routine cancer surgeries
                </span>
                , including:
              </p>
              <ul className="flex flex-col gap-2 pt-3 pb-3">
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">
                      Gynecologic Oncology Procedures Head & Neck Surgeries
                    </span>{" "}
                    : Commando Surgeries, Laryngectomy, Neck Dissection,
                    Thyroidectomy, Parotidectomy, Craniofacial Resections,
                    Parapharyngeal Tumor Excisions.
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">
                      Breast Cancer Surgeries
                    </span>{" "}
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">Urological Oncology</span> :
                    Kidney Cancer, Neobladder Reconstruction, Testicular Tumors,
                    Adrenal Tumors
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">
                      Gastrointestinal & Hepatobiliary (GI & HPB) Surgeries
                    </span>{" "}
                  </p>
                </li>
              </ul>
              <p className="text-base text-matcha font-normal py-2.5">
                He has many publications in national and international journals
              </p>
            </div>
            <div>
              <h2 className="lg:text-4xl md:text-3xl text-xl font-bold mt-2 text-matcha leading-tight">
                Professional Experience
              </h2>

              <ul className="flex flex-col gap-2 pt-3 pb-3">
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">Senior Residency</span> : MNJ
                    Institute of Oncology & Regional Cancer Centre, Hyderabad
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">Surgical Oncologist</span> :
                    Government General Hospital, Guntur (2 years of service
                    post-M.Ch)
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">
                      Director & Consultant Surgical Oncologist{" "}
                    </span>{" "}
                    : ARKA Hospital and Research Institute, Guntur (Founding
                    Member)
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="lg:text-4xl md:text-3xl text-xl font-bold mt-2 text-matcha leading-tight">
                Professional Memberships
              </h2>

              <ul className="flex flex-col gap-2 pt-3 pb-3">
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    Fellow of Indian Association of Gastrointestinal and
                    Endoscopic Surgeons (FIAGES)
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>The Association of Surgeons of India (ASI)</p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>Indian Medical Association (IMA)</p>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="lg:text-4xl md:text-3xl text-xl font-bold mt-2 text-matcha leading-tight">
                Papers and Publications
              </h2>

              <ul className="flex flex-col gap-2 pt-3 pb-3">
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">Dissertation</span> : Evaluation
                    of various procedures for Rectal Prolapse.
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">
                      Evaluation of Clinical Outcomes after Abdominal Rectopexy
                      and Delorme’s Procedure for Rectal Prolapse
                    </span>{" "}
                    : A ProspectiveStudy. J Clin Diagn Res. 2014;8(5): doi:
                    10.7860/ JCDR/2014/7787.4353
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <p>
                    {" "}
                    <span className="font-bold">
                      Giant peritoneal loose body
                    </span>
                    : a case report and review of literature. J Clin Diagn Res.
                    2014;8(1):187–8
                  </p>
                </li>
                <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                  <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                    <ChevronRight size={16} className="text-almond" />{" "}
                  </span>{" "}
                  <div>
                    {" "}
                    A Unique Case of Osteitis Fibrosa Cystica with Postoperative
                    Hungry Bone Syndrome and Hypocalcemic Cardiac Failure. World
                    Journal of Endocrine Surgery 7(1):10-13 January 2015.
                    <ul className="mt-2">
                      {" "}
                      <li className="flex flex-row items-start gap-3 text-base text-matcha font-normal">
                        <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                          <ChevronRight
                            size={16}
                            className="text-almond"
                          />{" "}
                        </span>{" "}
                        <div>
                          {" "}
                          Maturi Ramesh, Makineni Hemanth, Dayakar Kunwargiri,
                          Girish, Srinivasulu Mukta. (2016). LEARNING CURVES OF
                          LAPAROSCOPY – BARRIERS TO ADOPTION: A MNJIO
                          EXPERIENCE!. Journal of Evidence Based Medicine and
                          Healthcare. 3. 2680-2689. 10.18410/jebmh/2016/588.
                        </div>
                      </li>
                      <li className="flex flex-row items-start gap-3 mt-1.5 text-base text-matcha font-normal">
                        <span className="flex-shrink-0 w-5 h-5 mt-1 bg-matcha rounded-full flex justify-center items-center">
                          <ChevronRight
                            size={16}
                            className="text-almond"
                          />{" "}
                        </span>{" "}
                        <div>
                          {" "}
                          Billakanti R, Seshadri RA, Soma S, Makineni H,
                          Sundersingh S. Lymph Node Harvest After Neoadjuvant
                          Treatment for Rectal Cancer and Its Impact on
                          Oncological Outcomes. Indian J Surg Oncol. 2020
                          Dec;11(4):692-698. doi: 10.1007/s13193-020-01162-Y.
                          Epub 2020 Jul 24. PMID: 33281409; PMCID: PMC7714796.
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full xl:w-[40%] xl:my-0">
            <div className="lg:sticky lg:top-10 space-y-5">
              <div className="bg-matcha rounded-xl md:p-8 p-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="45"
                  viewBox="0 0 46 33"
                  fill="red"
                >
                  <g clipPath="url(#clip0_900_433)">
                    <path
                      d="M9.34276 32.8571C9.27489 32.8571 9.20702 32.8478 9.14149 32.8292C8.8349 32.7408 8.62427 32.4617 8.62427 32.1431V18.2602H0.718494C0.320631 18.2602 0 17.9392 0 17.5461V0.714033C0 0.320966 0.322971 0 0.718494 0H18.6879C19.0857 0 19.4064 0.320966 19.4064 0.714033V17.5322C19.4064 17.6671 19.3689 17.7997 19.294 17.9136L9.95126 32.5245C9.8202 32.7315 9.59084 32.8571 9.34276 32.8571ZM1.43699 16.8181H9.34276C9.74063 16.8181 10.0613 17.1391 10.0613 17.5322V29.6754L17.967 17.3229V1.42807H1.43699V16.8181Z"
                      fill="#e5d2bb"
                    />
                    <path
                      d="M35.9365 32.8571C35.8686 32.8571 35.8008 32.8478 35.7352 32.8292C35.4287 32.7408 35.218 32.4617 35.218 32.1431V18.2602H27.3122C26.9144 18.2602 26.5938 17.9392 26.5938 17.5461V0.714033C26.5938 0.31864 26.9167 0 27.3122 0H45.2816C45.6795 0 46.0001 0.320966 46.0001 0.714033V17.5322C46.0001 17.6671 45.9627 17.7997 45.8878 17.9136L36.545 32.5245C36.4139 32.7315 36.1846 32.8571 35.9365 32.8571ZM28.0307 16.8181H35.9365C36.3344 16.8181 36.655 17.1391 36.655 17.5322V29.6754L44.5608 17.3229V1.42807H28.0307V16.8181Z"
                      fill="#e5d2bb"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_900_433">
                      <rect width="46" height="32.8571" fill="black" />
                    </clipPath>
                  </defs>
                </svg>
                <div className="sm:text-4xl text-3xl font-bold text-[#fff] ">
                  Rest assured, you’re in safe hands. Together, we’ll put you on
                  a path to recovery.
                </div>
              </div>
              <button className="bg-matcha py-3 px-10 w-full text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-xl hover:bg-transparent hover:text-matcha duration-200 transition">
                Book An Appointment <ArrowRight strokeWidth={1} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutExp;
